module.exports = __webpack_public_path__ + "assets/480496c255342005d6b91eeff734178f.png";